var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 34 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2A2A",
  d: "M2.857 12.407c-2.539 7.814 1.737 16.205 9.55 18.744s16.205-1.737 18.744-9.55a14.8 14.8 0 0 0 .27-8.27 1.275 1.275 0 1 0-2.471.632c.573 2.24.507 4.6-.224 6.85-2.104 6.473-9.057 10.016-15.53 7.913-6.474-2.104-10.017-9.057-7.914-15.53 2.104-6.474 9.057-10.017 15.53-7.914a1.275 1.275 0 1 0 .789-2.425C13.788.318 5.396 4.594 2.857 12.407"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2A2A",
  d: "M29.802 4.217a1.275 1.275 0 0 0-1.785.255L16.058 20.417l-4.725-5.907-.129-.139a1.275 1.275 0 0 0-1.863 1.732l5.754 7.192.128.138a1.275 1.275 0 0 0 1.888-.17L30.057 6.003l.102-.159a1.275 1.275 0 0 0-.357-1.626"
})));
export default SvgRightMark;